import { SourceEntity } from 'types/SourceEntity'
import ApiBase from './Api'

type IssueFields = {
    statusStage: number
    statusComplete: boolean
}

type NewSource = {
    prId: string
    issueId?: string
    convertibleId?: string
    warrantId?: string
    sourceType: string
}

const SOURCE_API_PATHS = {
    SOURCES: '/sources',
    SOURCES_ADMIN: '/admin/sources',
}

class SourceApi extends ApiBase {
    async findByField({ prId, sourceUrl }: { prId?: string; sourceUrl?: string }) {
        const response: SourceEntity[] = await this._getRequest(SOURCE_API_PATHS.SOURCES, {
            queryParameters: {
                sourceUrl: sourceUrl ? encodeURI(sourceUrl) : null,
                prId: prId ?? null,
            },
        })
        return response
    }

    async findByIssueId(issueId: string) {
        const response: SourceEntity[] = await this._getRequest(SOURCE_API_PATHS.SOURCES, {
            queryParameters: { issueId },
        })
        return response
    }
    async findByWarrantId(warrantId: string) {
        const response: SourceEntity[] = await this._getRequest(SOURCE_API_PATHS.SOURCES, {
            queryParameters: { warrantId },
        })
        return response
    }
    async findByConvertibleId(convertibleId: string) {
        const response: SourceEntity[] = await this._getRequest(SOURCE_API_PATHS.SOURCES, {
            queryParameters: { convertibleId },
        })
        return response
    }
    async create(newSource: NewSource, issueFields?: IssueFields) {
        const response = await this._postRequest(SOURCE_API_PATHS.SOURCES_ADMIN, {
            ...newSource,
            issueFields,
        })
        return response
    }
}

export default SourceApi
